var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueDoubleCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 355,
    viewBox: "0 0 375 355",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-8 -412C203.912 -409.778 375 -238.925 375 -28.5C375 181.925 203.912 352.778 -8 355L265.927 -28.5L-8 -412Z",
    fill: "#8F69FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-12.1777 -411.969C160.044 -409.314 299 -238.646 299 -28.5C299 181.646 160.044 352.314 -12.1762 354.969C-13.5383 354.985 -14.8989 355 -16.2595 355C-223.771 355 -392 183.297 -392 -28.5C-392 -240.297 -223.771 -412 -16.2595 -412C-14.8989 -412 -13.5383 -411.985 -12.1777 -411.969ZM171.989 -28.5C171.989 -134.614 87.7091 -220.637 -16.2595 -220.637C-120.228 -220.637 -204.508 -134.614 -204.508 -28.5C-204.508 77.6141 -120.227 163.636 -16.2595 163.636C87.7076 163.636 171.989 77.6141 171.989 -28.5Z",
    fill: "#3957FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueDoubleCircle);
export default __webpack_public_path__ + "static/media/blue-double-circle.453ef490b77c654206012b1252a58036.svg";
export { ForwardRef as ReactComponent };